import { useIntl } from 'react-intl'
import { UseTranHook } from 'src/i18n/i18n.types'

export const useTran: UseTranHook = () => {
    const intl = useIntl()

    return (key, args) => intl.formatMessage({ id: key }, args)
}
